import { z } from "zod";

import {
  LOCATION_RADIUS_KM_MAX,
  LOCATION_RADIUS_KM_MIN,
} from "../constants/gamification-settings";
import { GAMIFICATION_SETTINGS_COPY } from "../constants/messages";

const RADIUS_RANGE_MESSAGE: string = GAMIFICATION_SETTINGS_COPY.radiusRange(
  LOCATION_RADIUS_KM_MIN,
  LOCATION_RADIUS_KM_MAX,
);

export const gamificationSettingsSchema = z.object({
  locationRadiusKm: z
    .number({
      required_error: RADIUS_RANGE_MESSAGE,
      invalid_type_error: RADIUS_RANGE_MESSAGE,
    })
    .int(RADIUS_RANGE_MESSAGE)
    .min(LOCATION_RADIUS_KM_MIN, RADIUS_RANGE_MESSAGE)
    .max(LOCATION_RADIUS_KM_MAX, RADIUS_RANGE_MESSAGE),
});

export type GamificationSettingsFormData = z.infer<
  typeof gamificationSettingsSchema
>;
